export const MODEL_CONVERSION_PRICE = 1; // price in euro
